import { ActionTypes } from "./actions";

function dtReducer(state, action) {
  switch (action.type) {
    case ActionTypes.INIT:
      return action.state;
    case ActionTypes.SEARCH:
      return { ...state, keyword: action.keyword,page:1 };
    case ActionTypes.SORT:
      return { ...state, sortDir: action.sortDir, sortBy: action.sortBy };
    case ActionTypes.PAGE:
      return { ...state, page: action.page };
    case ActionTypes.PAGE_LIMIT:
      return { ...state, pageLimit: action.limit };
    case ActionTypes.FILTER:
      return { ...state, appliedFilter: action.appliedFilter };
    default:
      return state;
  }
}

export default dtReducer;
